import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Switch,
  Typography,
} from "@mui/material";
import FormField from "../../../../components/common/FormField";

const ClientEditDialog = ({
  open,
  client,
  loading = false,
  tenantUpdate = false,
  onClose,
  onSubmit,
}) => {
  const [formError, setFormError] = useState("");
  const [allowUserCreation, setAllowUserCreation] = useState(true);
  const [privacyPolicy, setPrivacyPolicy] = useState("");

  useEffect(() => {
    if (!open) return;
    setFormError("");
    setAllowUserCreation(Boolean(client?.allowUserCreation));
    setPrivacyPolicy(String(client?.privacyPolicy || ""));
  }, [client, open]);

  const handleSubmit = async () => {
    if (tenantUpdate && !privacyPolicy.trim()) {
      setFormError("Privacy policy URL is required.");
      return;
    }

    setFormError("");
    try {
      await onSubmit(
        tenantUpdate
          ? { privacyPolicy: privacyPolicy.trim() }
          : { allowUserCreation }
      );
    } catch (err) {
      setFormError(err?.message || "Unable to update client.");
    }
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle sx={{ pb: 0.5, pt: 2, px: 2.5 }}>Edit Client</DialogTitle>
      <DialogContent sx={{ px: 2.5, pt: 1.5, pb: 1 }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Update settings for{" "}
          <strong>{client?.name || client?.clientId || "selected client"}</strong>
        </Typography>
        {formError ? (
          <Alert severity="error" sx={{ mb: 1.5 }} onClose={() => setFormError("")}>
            {formError}
          </Alert>
        ) : null}
        {tenantUpdate ? (
          <FormField
            label="Privacy Policy"
            value={privacyPolicy}
            onChange={(event) => setPrivacyPolicy(event.target.value)}
            placeholder="https://example.com/privacy-policy"
            disabled={loading}
          />
        ) : (
          <FormControlLabel
            control={
              <Switch
                checked={allowUserCreation}
                onChange={(event) => setAllowUserCreation(event.target.checked)}
              />
            }
            label="Allow user creation"
          />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 2.5, py: 1.5 }}>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? "Saving..." : "Save Changes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ClientEditDialog;
